import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {Handle} from 'reactflow';
//import {Handle} from 'react-flow-renderer';
import {Form} from '../';
import {Chatbot} from '../../states/actions';
import {useSelector, shallowEqual} from 'react-redux';
import {onSuccess, onEdit, onSetStart, onRemove, onClose, isLightColor} from '../../helpers/block-helper';
import {Link} from 'react-router-dom';
import {IntNodeComponent, InputComponent, SelectComp} from './Components'
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';



export const SheetBlock = React.memo((node) => {
  const {block, start} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const [documents, setdocuments] = useState([]);
 
 
  useEffect(() => {
    const fetchDocuments = async () => {
      const {documents} = await Chatbot.fetchDocuments();
      setdocuments(documents?.map((i) => ({label: i.name, value: i.id})));
    };
    fetchDocuments();
  }, []);

  if (!block) {
    return null;
  }
  const {data} = block;

  return (
    <>
        <IntNodeComponent name="Sheet" icon="sheet" data={data} node={node} start={start}/>
    </>
  );
});

export const SheetEditor = ({nodeid, block}) => {
  
  //Need to fetch only spreadthseet documents

  const [documents, setdocuments] = useState([]);
  useEffect(() => {
    const fetchSheets = async () => {
      const {documents} = await Chatbot.fetchSheets();
      setdocuments(documents?.map((i) => ({label: i.name, value: i.id})));
    };
    fetchSheets();
  }, []);

  const {data} = block;

  if (!block) {
    return null;
  }

  const handleBlur = (e) => {   
    Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
  };


return (
  <>
         
         {/* <Form url="/block/document" initialValues={data} onSuccess={onSuccess} successNotification={false}>
             */}

              <div className="mb-2">
 
                <label htmlFor="documentId" className="form-label comp-header">
                  Spreadsheet
                </label>
                <Select
                  id="documentId"
                  name="documentId"
                  options={documents}
                  placeholder="Select Document"
                  value={documents?.find((i) => i.value === data.documentId)}
                  className="form-control form-control-sm editor-select"
                  classNamePrefix="editor-select"
                  onChange={(option) => {
                    Chatbot.setBlockData(block.id, {documentId: option.value, documentName: option.label});
                  }}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderRadius: 0,
                      border: 'none',
                    }),
                  }}
                />

              </div>



              
              <InputComponent data={data} name="Sheet name" dataname="sheetName" onBlur={handleBlur}/>

              <InputComponent data={data} name="Waiting message" dataname="waitmessage" onBlur={handleBlur}/>


              
              <a target="_blank" rel="noreferrer" href={`https://docs.google.com/spreadsheets/d/${data.documentId}/edit`}>
                 Open spreadsheet
               </a>


         {/* </Form> */}

         
  </>
  

)
};